import { PaginationMetadata } from '@services/providers/cosem.types';
import { createColumnHelper } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { SocialBenefit, SocialBenefitListItem } from '@services/member/member/member.types';
import { useGetSocialBenefitsMutation } from '@services/member/list/social-benefits/social-benefits.endpoints';

export const useSocialBenefitEditionPageVM = () => {

    const [totalSocialBenefits, setTotalSocialBenefits] = useState<number>(0);
    const [socialBenefitsItems, setSocialBenefitsItems] = useState<SocialBenefitListItem[]>([]);
    const columnHelper = createColumnHelper<SocialBenefit>();

    const navigate = useNavigate();

    const [getSocialBenefitsItems, { isSuccess: isGetSocialBenefitsSuccess, isLoading: isGetSocialBenefitsLoading, data: socialBenefitsData }] =
    useGetSocialBenefitsMutation();

    useEffect(() => {
        getSocialBenefitsItems(undefined);
    }, []);

    useEffect(() => {
        if (isGetSocialBenefitsLoading) return;
        if (isGetSocialBenefitsSuccess && socialBenefitsData) {
            setSocialBenefitsItems(socialBenefitsData.data);
        }
    }, [isGetSocialBenefitsSuccess]);

       const handleMetadata = (metadata: PaginationMetadata) => {
        if (metadata && metadata.total !== undefined) {
            setTotalSocialBenefits(metadata.total);
        }
    };

    return {
        handleMetadata,
        navigate,
        columnHelper,
        socialBenefitsItems,
        totalSocialBenefits
    };
};
